export default __webpack_public_path__ + "static/media/beep.0c78daeb.mp3";